import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.keyHandler = this.keyHandler.bind(this)
    document.addEventListener('keydown', this.keyHandler)
    // close when clicking overlay (but not when clicking inside modal wrapper)
    this.element.addEventListener('click', (e) => {
      if (e.target === this.element) this.close()
    })
  }

  disconnect() {
    document.removeEventListener('keydown', this.keyHandler)
  }

  keyHandler(e) {
    if (e.key === 'Escape') this.close()
  }

  close() {
    // Remove modal frame content (turbo frame 'modal') if present
    const modalFrame = document.getElementById('modal')
    if (modalFrame) {
      modalFrame.innerHTML = ''
      // If Turbo Frame exists, request replacement so nothing remains
    }
  }
}

